import React from 'react';
import { useLogin } from '@privy-io/react-auth';
import { Button, Grid, Stack, Typography } from '@mui/material';

export const LoginBanner: React.FC<{
  title: string;
}> = ({ title }) => {
  const { login } = useLogin();

  return (
    <Grid item xs={12}>
      <Stack
        padding={3}
        alignItems={'center'}
        justifyContent={'center'}
        borderRadius={2}
        sx={{
          backgroundColor: '#fff',
        }}
      >
        <Typography>{title}</Typography>
        <Button onClick={login}>Login</Button>
      </Stack>
    </Grid>
  );
};

export default LoginBanner;
